import React, { useEffect, useState } from 'react';
// Constants
import { CompanyName } from '../../utils/Constants';
// Data
import {
  bookingPageAdditionalMeta,
  bookingPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import BookingPageMainContainer from '../../components/booking/BookingPageMainContainer';
import { HelmetItem } from '../../components/utils/HelmetItem';
import Navbar from '../../components/nav/Navbar';
import PageDivider from '../../components/gallery/PageDivider';
import GeneralHeader from '../../components/header/GeneralHeader';

function BookingPage() {
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('scroll-section-booking');
      if (!section) return;

      const sectionBottom = section.getBoundingClientRect().bottom;
      setHideNavbar(sectionBottom <= 130); // Hide navbar 50px before section disappears
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Booking'
        desc={`Book a session or consultation with Miss Dominatrixa. Secure your experience today for unforgettable, tailored domination services.`}
        keywords={`booking, session, consultation, dominatrix, Miss Dominatrixa, BDSM services`}
        additionalMeta={bookingPageAdditionalMeta}
        structuredData={bookingPageStructuredData}
      />

      {/* Page */}
      <div className='grid grid-rows-reg min-h-screen font-main bg-colour1 dark:bg-colour1 text-colour2 dark:text-colour2 overflow-hidden'>
        {/* Nav + header section */}
        <div
          id='scroll-section-booking'
          className='grid bg-colour4 dark:bg-colour4 full_shadow_black_invert min-h-[45vh] max-h-[45vh]'
        >
          {/* Navigation */}
          <Navbar isHidden={hideNavbar} />

          {/* Divider */}
          <PageDivider />

          {/* Header */}
          <GeneralHeader
            page={`Book A Session`}
            title={`Confirm you date with Miss Dominatrixa!`}
          />
        </div>

        {/* Main */}
        <BookingPageMainContainer />
      </div>
    </>
  );
}

export default BookingPage;
